import { render, staticRenderFns } from "./bgMusic.vue?vue&type=template&id=0ec6df00&scoped=true&"
import script from "./bgMusic.vue?vue&type=script&lang=js&"
export * from "./bgMusic.vue?vue&type=script&lang=js&"
import style0 from "./bgMusic.vue?vue&type=style&index=0&id=0ec6df00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec6df00",
  null
  
)

export default component.exports